/**
 * Tablo tarih hücresi — **el** mertebesi: mutlak zaman + göreli zaman.
 * Liste ekranlarında aynı hücre kopyalanıyordu; tek kaynak.
 */

import { goreliZaman, tarihSaatYaz } from '../lib/format';

export function TarihHucresi({ zaman }: { zaman: string }) {
  return (
    <div className="flex flex-col whitespace-nowrap">
      <span className="rakam text-sm text-[var(--ink)]">{tarihSaatYaz(zaman)}</span>
      <span className="text-xs text-[var(--ink-faint)]">{goreliZaman(zaman)}</span>
    </div>
  );
}
